import React, { useEffect, useState } from "react";
import { api, asAbsolute } from "@/lib/api";
import { toast } from "sonner";
import { UploadCloud, Loader2 } from "lucide-react";

/**
 * Reusable image / file uploader.
 * onUploaded is called with { url, path, content_type }
 */
export default function FileUploader({ kind = "image", onUploaded, current, accept, label = "Upload" }) {
    const [busy, setBusy] = useState(false);
    const handle = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        setBusy(true);
        try {
            const fd = new FormData();
            fd.append("file", file);
            fd.append("kind", kind);
            const r = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
            onUploaded?.(r.data);
            toast.success("Uploaded");
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Upload failed");
        } finally { setBusy(false); }
    };

    return (
        <label className="inline-flex items-center gap-3 cursor-pointer">
            <div className="w-16 h-16 rounded-md bg-slate-100 overflow-hidden grid place-items-center border border-slate-200 flex-shrink-0">
                {current && kind === "image" ? (
                    <img src={asAbsolute(current)} alt="" className="w-full h-full object-cover" />
                ) : (
                    <UploadCloud size={20} className="text-slate-400" strokeWidth={1.5} />
                )}
            </div>
            <div>
                <div className="text-sm font-medium text-slate-800">{label}</div>
                <div className="text-xs text-slate-500">{kind === "image" ? "JPG / PNG / WEBP · max 15 MB" : "PDF · max 15 MB"}</div>
                <input
                    type="file"
                    accept={accept || (kind === "image" ? "image/*" : "application/pdf")}
                    onChange={handle}
                    className="hidden"
                    data-testid="file-input"
                />
                <div className="mt-1 inline-flex items-center gap-2 text-xs text-brand-forest font-semibold">
                    {busy ? <><Loader2 size={12} className="animate-spin" /> Uploading…</> : "Choose file"}
                </div>
            </div>
        </label>
    );
}
